// NPM Imports
import React, { Fragment } from "react";
import moment from "moment";

// Components Imports
import DateSelect from "../../DateSelect";

export default class RevvGridDate extends React.Component {
  state = {
    showComponent: false,
  };

  render() {
    const { field, readOnly, row } = this.props;
    const cellValue = row.rowData[field] ? row.rowData[field].cellData : "";
    const editable =
      row.rowData[field] &&
      row.rowData[field].cellMeta &&
      row.rowData[field].cellMeta.editable;
    return (
      <Fragment>
        {this.state.showComponent && (
          <DateSelect
            autoFocus
            onBlur={() => this.setState({ showComponent: false })}
            onCalendarClose={() => this.setState({ showComponent: false })}
            selectedDate={cellValue}
            returnValue={date =>
              this.props.onChange(moment(date).toISOString())
            }
          />
        )}
        {!this.state.showComponent && (
          <div
            className={`rs-cell ${editable && !readOnly ? "is-editable" : ""}`}
            onClick={() =>
              editable && !readOnly && this.setState({ showComponent: true })
            }
            onKeyPress={() => null}
            role="button"
            tabIndex="0">
            {moment(cellValue).format("L")}
          </div>
        )}
      </Fragment>
    );
  }
}
